// extracted by mini-css-extract-plugin
export default {"link":"NK-z","disabled":"OK-z"};